import axios from "axios";
import React, { useState, useEffect } from "react";
import BaseURL from "../../Util/BaseURL";
import toastify from "../../Util/toastify";
import Adminnav from "../Adminnav";
import "./RemoveCoupons.css";
const RemoveSeller = () => {
  const [sellers, setSellers] = useState();

  function remove(props) {
    axios.delete(`${BaseURL}DeleteSeller?name=${props}`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    document.getElementById(props).style.display = "none";
    toastify("Seller Removed Successfully", "success");
  }
  const getSellers = async () => {
    const response = await axios.get(`${BaseURL}GetSellers`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    setSellers(response.data);
  };
  useEffect(() => {
    getSellers();
  }, []);

  return (
    <>
      <Adminnav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Remove Seller</h1>
          </div>
        </div>
      </section>
      <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 h-100 w-100 p-5 mx-auto">
        {sellers
          ? sellers.map((data,key) => (
              <div key={key}
                className="col singleCard card target py-5"
                id={data.sellerId}
              >
                <div className="col card-body text-center">
                  <h4>{data.sellerId}</h4>
                  <h6>Owner Name: {data.ownerName}</h6>
                  <button
                    className="btn btn-success rmvSeller"
                    onClick={() => remove(data.sellerId)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))
          : ""}
      </div>
    </>
  );
};

export default RemoveSeller;
